export const NEWBUILDING_KPN_CHAT = 'newbuilding_kpn_chats_jk_desktop';
export const NEWBUILDING_CONFIDENT_BOOKING_CARDJK_WEB = 'newbuilding_confident_booking_cardjk_web';
